import { atom } from 'jotai'
export const sidebarContainerAtom = atom<HTMLElement | null>(null)
